<template>
    <div class="float">
        <div class="contact" @click="handleContact"><p>联系我们</p></div>
    </div>
</template>

<script>
export default {
    name:'float',
    methods:{
        handleContact(){
            this.$router.push({ path: '/contact' })
        }
    }
}
</script>

<style scoped>
.contact{
  color:#fff;
  background-color: #f9a72a;
  text-align: center;
  line-height: 100px;
  cursor: pointer;
  width: 100px;
  height: 100px;
  border-radius: 50%;
  position:fixed;
  z-index: 4;
  right: 10px;
  bottom:10%
}
@media screen and (max-width: 768px){
  .contact{display: none}
}
</style>





// WEBPACK FOOTER //
// src/components/float.vue